import { checkFullPath } from "../../utils";
import { Game } from "../models/Game";

class AARPAdUnitsMeta {
  private baseAdUnits = [
    this.buildAdUnit(1, "aarpe-eng"),
    this.buildAdUnit(2, "games"),
  ];
  private baseAdUnitSource = {
    id: "aarpAdUnitSource",
    name: "aarpAdUnitSource",
    content: "arkadium",
  };

  homepage() {
    return [
      ...this.baseAdUnits,
      this.buildAdUnit(3, "homepage"),
      this.baseAdUnitSource,
      this.adUnitCustom(),
    ];
  }

  category(category: string) {
    return [
      ...this.baseAdUnits,
      this.buildAdUnit(3, category.toLowerCase().replace(" ", "-")),
      this.buildAdUnit(4, "category"),
      this.baseAdUnitSource,
      this.adUnitCustom(),
    ];
  }

  game(game: Game) {
    if (!game || !game.categories.length) {
      return [];
    }

    return [
      ...this.baseAdUnits,
      this.buildAdUnit(
        3,
        game.isSpain()
          ? "espanol"
          : game.categories[0].toLowerCase().replace(" ", "-")
      ),
      this.buildAdUnit(4, "gameplay"),
      this.baseAdUnitSource,
      this.adUnitCustom(game.seo_adUnitCustom || game.slug),
      this.ogImage(game),
    ];
  }

  private ogImage(game) {
    const buildImageUrl = checkFullPath(game.assetOriginUrl, game.promoThumbPath);
    return {
      property: "og:image",
      content: buildImageUrl.toString(),
    };
  }
  private adUnitCustom(game?) {
    return {
      id: "aarpAdUnitCustom",
      name: "aarpAdUnitCustom",
      content: `gamename=${game || null}`,
    };
  }

  private buildAdUnit(num, content) {
    return {
      id: "aarpAdUnit" + num,
      name: "aarpAdUnit",
      content,
    };
  }
}

export default new AARPAdUnitsMeta();
